// Real game icons (copied verbatim from aitech.tapper) for the play preview, so the
// reward tiles + ability chips match the game 1:1 instead of react-icons placeholders.
import { AvatarAbility } from '@common/contracts';
import Strength from '../assets/stats/Strength.webp';
import Agility from '../assets/stats/Agility.webp';
import PsiEnergy from '../assets/stats/PsiEnergy.webp';
import Intelligence from '../assets/stats/Intelligence.webp';
import Defense from '../assets/stats/Defense.webp';
import MoveIcon from '../assets/stats/MoveIcon.webp';
import KnowledgeReward from '../assets/rewards/Knowledge.webp';
import PowerReward from '../assets/rewards/Power.webp';
// AbilityType → stat icon, mirroring the game's getChallengePreview map.
// (game PerceptionOrPsiEnergy → PsiEnergy; editor calls it Perception.)
export const ABILITY_ICON = {
    [AvatarAbility.Strength]: Strength,
    [AvatarAbility.Agility]: Agility,
    [AvatarAbility.Perception]: PsiEnergy,
    [AvatarAbility.Intellect]: Intelligence,
    [AvatarAbility.Defence]: Defense,
};
// Ordered by GameAbilityType (0 Strength, 1 Perception/PsiEnergy, 2 Agility,
// 3 Defense, 4 Intellect) — the agent/gear stat plates are indexed by that enum.
export const STAT_ICON_BY_TYPE = [Strength, PsiEnergy, Agility, Defense, Intelligence];
// Dice-result reward icon: success → Knowledge, failure/loss → Power
// (hardcoded in the game's RollTheDice, not data-driven).
export { KnowledgeReward, PowerReward, MoveIcon };
// Field cell status markers (game src/assets/challenges/Field/*).
import FieldBlue from '../assets/field/Blue.webp'; // NotStarted, retryable
import FieldRed from '../assets/field/Red.webp'; // NotStarted, one-shot
import FieldCrossBlue from '../assets/field/CrossBlue.webp'; // Failed, retryable
import FieldCrossRed from '../assets/field/CrossRed.webp'; // Failed, one-shot
import FieldDetect from '../assets/field/Detect.webp'; // Succeded, unscanned
import FieldTransmit from '../assets/field/Transmit.webp'; // scanned, not transmitted
import FieldCompleted from '../assets/field/Completed.svg'; // transmitted (done)
import FieldLocked from '../assets/field/Locked.webp'; // locked
export const FIELD_MARKER = {
    blue: FieldBlue, red: FieldRed, crossBlue: FieldCrossBlue, crossRed: FieldCrossRed,
    detect: FieldDetect, transmit: FieldTransmit, completed: FieldCompleted, locked: FieldLocked,
};
